import React, { useState } from 'react';
import classnames from 'classnames';

// TODO: emailJs
// import { SendForm } from 'api/forms';

import FormElem from './components/FormElem';
import Success from './components/Success';

import useOptions from 'hooks/graphql/useOptions';

import * as styles from './subscribeFormFull.module.scss';

const SubscribeFormFull = () => {
  const [seccess, setSuccess] = useState(false);
  const options = useOptions();

  const { subscribeFormFull } = options.subscribeFormFull;
  const { subscribeFormFullSuccessState } = subscribeFormFull;

  const handleSubmit = (values) => {
    // TODO: emailJs
    // SendForm(values, 'subscribe_form');
    console.info(values, 'subscribe_form_full');

    setTimeout(() => {
      setSuccess(!seccess);
    }, 400);
  };

  return (
    <div className={classnames(styles.container)}>
      {!seccess ? (
        <>
          <div className={classnames(styles.formWrap)}>
            <FormElem
              data={subscribeFormFull}
              onSubmit={(values) => handleSubmit(values)}
            />
          </div>
        </>
      ) : (
        <Success data={subscribeFormFullSuccessState} />
      )}
    </div>
  );
};

export default SubscribeFormFull;
